import { growthBookRef } from './config.ts';
import {
  FLAG_REGISTRY,
  type FlagDefinitionFor,
  type FlagKey,
} from './registry.ts';
import type { FlagDefinition, FlagValue, PermanentFlagValue } from './types.ts';

export function resolveFlag<D extends FlagDefinition>(
  definition: D,
  gbValue: PermanentFlagValue | null | undefined,
): FlagValue<D> {
  return (gbValue ?? definition.defaultValue) as FlagValue<D>;
}

export function readFlagValue<K extends FlagKey>(
  key: K,
): FlagValue<FlagDefinitionFor<K>> {
  const definition = FLAG_REGISTRY[key] as FlagDefinition;
  const gb = growthBookRef?.value;
  const rawValue = gb
    ? gb.getFeatureValue(key as string, definition.defaultValue)
    : definition.defaultValue;
  return resolveFlag(definition, rawValue) as FlagValue<FlagDefinitionFor<K>>;
}
